import {showFromFade} from "../../js/Util";

let $contactTab = $(".js-contact-tab");
let $activeTab = $contactTab.filter("._active");
let $tabsContent = $(".js-contact-content__elem");
$tabsContent.removeClass("_active").hide();
let $activeTabContent = $tabsContent.eq($activeTab.index());
$activeTabContent.addClass("_active").show();

$contactTab.click(function () {
    let $el = $(this);
    let currentTab = $el.data("switch");

    $(".js-contact-tabs").find("._active").removeClass("_active");
    $el.addClass("_active");
    $(".js-contact-content").find(".js-contact-content__elem").hide();
    $("#" + currentTab).show();
    let idMap = $("#" + currentTab).find(".map>div").attr("id");
    let lat = Number($("#" + currentTab).find(".map>div").attr("data-lat"));
    let lng = Number($("#" + currentTab).find(".map>div").attr("data-lng"));

    setTimeout(() => {
        initMap(idMap, lat, lng);
    }, 100);
});

$("#cityes").on("select2:select", function (e) {
    let currentTab = e.params.data.id;

    $(".js-contact-content").find(".js-contact-content__elem").hide();
    $("#" + currentTab).show();
    let idMap = $("#" + currentTab)
        .find(".map")
        .children("div")
        .attr("id");
    let lat = Number(
        $("#" + currentTab)
            .find(".map")
            .children("div")
            .attr("data-lat")
    );
    let lng = Number(
        $("#" + currentTab)
            .find(".map")
            .children("div")
            .attr("data-lng")
    );

    setTimeout(() => {
        initMap(idMap, lat, lng);
    }, 100);
});

function initMap(id, lat, lng) {
    let uluru = {lat: lat, lng: lng};
    let map = new google.maps.Map(document.getElementById(id), {
        zoom: 16,
        center: uluru,
    });
    new google.maps.Marker({
        position: uluru,
        map: map,
    });
}

if (App.H.hasClass("page-contacts") && $activeTabContent.length) {
    let idMap = $activeTabContent.find(".map>div").attr("id");
    let latStart = Number($activeTabContent.find(".map>div").attr("data-lat"));
    let lngStart = Number($activeTabContent.find(".map>div").attr("data-lng"));

    setTimeout(() => {
        initMap(idMap, latStart, lngStart);
    }, 100);
}

if ($(".contact-tile").length) {
    $(".contact-tile").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}

if ($(".form-contacts-wrap").length) {
    $(".form-contacts-wrap").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
